angular.module('mtic.components.modules.c3', [

]).constant('C3_ASSET_URL', 'assets/images/c3-module/').constant('C3_META_ASSET_URL', 'assets/images/c3-meta/')
